var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoVerifiedOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 13.61L9.37999 16.01C9.77999 16.4 10.41 16.4 10.82 16.01L16.74 10.07C17.13 9.68 17.13 9.05 16.74 8.66L16.67 8.59C16.28 8.2 15.64 8.2 15.25 8.59L10.1 13.75L8.48999 12.13C8.09999 11.74 7.45999 11.74 7.06999 12.13L6.99999 12.2C6.60999 12.59 6.60999 13.22 6.99999 13.61Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.56 14.79L23 12L20.56 9.21L20.9 5.52L17.29 4.7L15.4 1.5L12 2.96L8.6 1.5L6.71 4.69L3.1 5.5L3.44 9.2L1 12L3.44 14.79L3.1 18.49L6.71 19.31L8.6 22.5L12 21.03L15.4 22.49L17.29 19.3L20.9 18.48L20.56 14.79ZM18.7476 7.08204L18.4897 9.88082L20.3431 12L18.4897 14.1192L18.7476 16.918L16.0079 17.5403L14.5748 19.9591L11.9973 18.8522L9.42292 19.9653L7.99208 17.5503L5.25197 16.9279L5.51009 14.119L3.65489 11.9976L5.5099 9.86895L5.2524 7.06678L7.99049 6.45242L9.42516 4.03093L12 5.1366L14.5726 4.03189L16.0063 6.45937L18.7476 7.08204Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVerifiedOutline);
export default __webpack_public_path__ + "static/media/ico-verified-outline.d6fa096aba238962fa5a78ad100e78cd.svg";
export { ForwardRef as ReactComponent };